import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import { map, noop, isEmpty } from 'lodash';
import { commaFormatted, dateFormat } from '../../../../utils/transformer.util';
import Button from '../../../../components/base/Button/Button.component';
import { printBukuInduk } from '../../../../utils/print.util';
import ListForm from '../../../../components/ListForm/ListForm.component';
import { LAPORAN_8355_FORM } from '../../../../constants/student.constant';
import { Input, Select } from '../../../../components/base/index';
import { GENDER } from '../../../../variables/common.variable';
import ReactToPrint from "react-to-print";

function onClickPrint(header, content, footer) {
  printBukuInduk(header, content, footer);
}

class ComponentToPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      journal: {},
    };
    this.onGetDetails = this.onGetDetails.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
  }

  // componentDidMount() {
  //   this.onGetDetails();
  // }

  async onGetDetails() {
    const { handleGetCashJournal, match } = this.props;
    const { id } = match.params;
    try {
      const payload = await handleGetCashJournal({ id });
      this.setState({
        journal: payload,
      });
    } catch (err) {
      // err action
    }
  }

  _onFormChange(event) {
      const { onChange } = this.props;
      onChange(event);
    }
  


  render() {
    const { journal } = this.state;
    return (
      
     <div>
       
        {/* <Button
          title="Cetak Ke Printer"
          onClick={() => {
            onClickPrint('detail-cash-journal__header',
              'detail-cash-journal__table',
              'detail-cash-journal__footer');
          }}
        /> */}
        <div id="divPrint" style={{width:800, border: '0px solid black'}}>
       
                <div className="laporan-ki2__content">
                  <div className="laporan-ki2__header">
                      <div className="laporan-ki2__custom-form-row-square">
                          <div className="laporan-ki2__box--square2">
                              Image
                          </div>
                          
                            <div className="laporan-ki2__header-title">
                                <div className="laporan-ki2__header-title--column">
                                    {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                                    LAPORAN HASIL BELAJAR SISWA
                                </div>
                                
                                
                                    <div className="laporan-ki2__header-title--column">
                                        {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                                        SEKOLAH MENENGAH PERTAMA
                                    </div>
                                    
                            </div>
                        </div>
                    </div>
                </div>  
                    <div className="laporan-ki2__header-title3">
                        <div className="laporan-ki2__header-title3--left">
                            <table className="laporan-ki2__table-test">
                                <tr> 
                                    <td></td>    
                                    <td>Nama Siswa </td>
                                    <td>  : Gange</td> 
                                </tr> 
                                <tr>
                                    <td></td>
                                    <td>Nomor Induk </td>
                                    <td>  : SMP Katolik Ricci</td> 
                                    
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>No.ID.Reg</td>
                                    <td>  : SMP Katolik Ricci</td> 
                                    
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>Nama Sekolah</td>
                                    <td>  : SMP Katolik Ricci</td> 
                                    
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>Alamat Sekolah</td>
                                    <td>  : SMP Katolik Ricci</td> 
                                    
                                </tr>
                                
                            </table> 
                        </div>
                        
                        
                        <div className="laporan-ki2__header-title3--right">
                            <table className="laporan-ki2__table-test">
                                <tr> 
                                    <td></td>    
                                    <td>Tahun Ajaran </td>
                                    <td>  : SMP Katolik Ricci</td> 
                                </tr> 
                                <tr>
                                    <td></td>
                                    <td>Periode</td>
                                    <td>  : SMP Katolik Ricci</td> 
                                    
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>Kelas / No.Absen</td>
                                    <td>  : SMP Katolik Ricci</td> 
                                        
                                </tr>
                            </table>
                        </div>
                     </div>

                     <div className="laporan-ki2__header-title-table">
                        A. Sikap
                    </div>

                     <div className="laporan-ki2__body">
                         <table className="laporan-ki2__table">
                             <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>ASPEK</th>
                                    <th>PREDIKAT</th>
                                    <th>DESKRIPSI</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                         </table>
                     </div>

                     <div className="laporan-ki2__header-title-table">
                        B. Pengetahuan
                    </div>

                     <div className="laporan-ki2__body">
                         <table className="laporan-ki2__table">
                             <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>MATA PELAJARAN</th>
                                    <th>KKM</th>
                                    <th>NILAI</th>
                                    <th>PREDIKAT</th>
                                    <th>DESKRIPSI PENGETAHUAN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="kelompok"colSpan={6}>Kelompok A</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th className="kelompok"colSpan={6}>Kelompok B</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                         </table>
                     </div>

                     
                     <div className="laporan-ki2__header-title-table">
                        C. Keterampilan
                    </div>

                     <div className="laporan-ki2__body">
                         <table className="laporan-ki2__table">
                             <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>MATA PELAJARAN</th>
                                    <th>KKM</th>
                                    <th>NILAI</th>
                                    <th>PREDIKAT</th>
                                    <th>DESKRIPSI PENGETAHUAN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="kelompok"colSpan={6}>Kelompok A</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th className="kelompok"colSpan={6}>Kelompok B</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                         </table>
                     </div>
                     
                     <div className="laporan-ki2__header-title-table">
                        D. Keterampilan
                    </div>

                     <div className="laporan-ki2__body">
                         <table className="laporan-ki2__table">
                             <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>EKSTRAKULIKULER</th>
                                    <th>NILAI</th>
                                    <th>DESKRIPSI</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                         </table>
                     </div>

                     <div className="laporan-ki2__header-title-table">
                        E. Ketidakhadiran
                    </div>

                     <div className="laporan-ki2__body">
                         <table className="laporan-ki2__table">
                             <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>KETIDAKHADIRAN</th>
                                    <th>KETERANGAN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>SAKIT</td>
                                    <td>-Hari</td>
                                </tr>
                            </tbody>
                         </table>
                     </div>

                    <div className="laporan-ki2__header-title2">
                        <div className="laporan-ki2__header-title2--column">
                            <div className="laporan-ki2__header-title2--bold">
                                Keputusan
                            </div>
                        <div className="laporan-ki2__header-title2--column">
                            Berdasarkan hasil yang dicapai pada Semester I dan II,
                        </div>
                        <div className="laporan-ki2__header-title2--column">
                            maka peserta didik ditetapkan
                        </div>
                        <div className="laporan-ki2__header-title2--row">
                            <div className="laporan-ki2__header-title2--bold">
                                NAIK/TIDAK NAIK
                            </div>
                            <div className="laporan-ki2__header-title2--row">
                                &nbsp;ke kelas VII
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="laporan-ki2__custom-form-row">
                        <div className="laporan-ki2__custom-form-row__field">

                            <div className="laporan-ki2__custom-form-column">
                                <p>Mengetahui</p>
                                <div className="laporan-ki2__custom-form-column">
                                    <p>Orang Tua Wali</p>
                                </div>
                                <div className="laporan-ki2__custom-form-column__field">
                                    <p>.....................................</p>
                                </div>
                            </div>

                            <div className="laporan-ki2__custom-form-column3">
                                <p>Wali Kelas</p>
                                <div className="laporan-ki2__custom-form-column3__field">
                                    <p>(&emsp; &emsp; &emsp; &emsp; &emsp;)</p>
                                </div>
                            </div>

                            <div className="laporan-ki2__custom-form-column2">
                                <p>Jakarta Selatan,</p>
                                <div className="laporan-ki2__custom-form-column">
                                    <p>Kepala Sekolah / Kepala Satuan</p>
                                </div>
                                    <div className="laporan-ki2__custom-form-column">
                                        <p>Pendidikan</p>
                                    </div>
                                        <div className="laporan-ki2__custom-form-column">
                                            <p>Unit Sekolah</p>
                                        </div>
                                <div className="laporan-ki2__custom-form-column2__field">
                                    <p>(&emsp; &emsp; &emsp; &emsp; &emsp;)</p>
                                </div>
                            </div>

                        </div>
                     </div>
                   
               
             
            
      </div>
      </div>
    );
  }

}
export default class LaporanHasilKI2 extends Component {
  constructor(props){
    super(props);

    this.state={
      journal: {},
    }
  }

  
  render() {
    return (
      <div className="content-wrapper">
          <section className="content-header">
              <div className="row">
                  <div className="col-md-12">
                      <div className="box">

                        <div className="divContainter">
                          <div>
                            <ReactToPrint
                              trigger={() =>  <Button style={{marginBottom:10}} block>Print</Button>}
                              content={() => this.componentRef}
                            />
                            <ComponentToPrint ref={el => (this.componentRef = el)} />
                          </div>

                        </div>
                      </div>
                  </div>
              </div>
          </section>
      </div>
      
    );
  }
}
LaporanHasilKI2.propTypes = {
    handleGetCashJournal: PropTypes.func,
    match: PropTypes.object.isRequired,
  };
LaporanHasilKI2.defaultProps = {
    handleGetCashJournal: noop,
  };
  